module.exports = __webpack_public_path__ + "img/pr-27.c6771e41.png";